import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { OrderStatusTitle } from "../../../../Constants/Constants";
import { OrderStatusChart } from "../../../../Data/General/Widgets/Chart";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const OrderStatus = () => {
  return (
    <Col xl="7" lg="12" className="box-col-7">
      <Card>
        <CommonCardHeader title={OrderStatusTitle} />
        <CardBody>
          <div className="chart-container">
            <div id="linechart">
              <ReactApexChart options={OrderStatusChart} series={OrderStatusChart.series} type="line" height={350} />
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderStatus;
